import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1719400471588-575b23e27bd7?crop=entropy&cs=srgb&fm=webp&auto=format,compress&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxzb2Z0d2FyZSUyMGRldmVsb3BlciUyMGNvZGluZyUyMGRhcmslMjByb29tfGVufDB8fHx8MTc4NTQwMDYxNXww&ixlib=rb-4.1.0&q=85";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="relative border-t border-hairline py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-14">
        <div className="md:col-span-5 order-2 md:order-1">
          <div className="relative aspect-[3/4] w-full max-w-[440px] clipped-frame overflow-hidden bg-[#0b0e18] border border-hairline grain">
            <motion.img
              src={ABOUT_IMG}
              alt="Developer workspace"
              style={{ y }}
              className="absolute inset-0 w-full h-[115%] object-cover opacity-85"
              loading="lazy"
            />
            <div className="absolute left-4 bottom-4 mono-label !text-white/70">Pune HQ · 07:42</div>
          </div>
        </div>

        <div className="md:col-span-7 order-1 md:order-2">
          <span className="mono-label">[07] About</span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-15% 0px" }}
            transition={{ duration: 0.7 }}
            className="mt-4 font-display text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[0.98]"
          >
            A software team that
            <br />
            <span className="text-[color:var(--accent)]">writes production code,</span>
            <br />
            <span className="text-white/40">not slide decks.</span>
          </motion.h2>

          <div className="mt-10 grid md:grid-cols-2 gap-8 md:gap-12">
            <p className="text-white/70 text-[16px] leading-[1.7]">
              Beacon IT Solution is a Pune, India-based software development company specializing in
              <span className="text-white"> CRM, eCommerce and API engineering</span>. We combine
              traditional full-stack expertise with modern AI-assisted development practices to
              deliver production-ready software efficiently.
            </p>
            <p className="text-white/70 text-[16px] leading-[1.7]">
              We work with founders, product teams and enterprise engineering orgs across the US,
              EU and APAC. Our unfair advantage is a senior team that has been delivering since
              <span className="text-white"> 2012</span> — plus an agentic AI workflow that
              compresses months of engineering into weeks. We are also a{" "}
              <a
                href="https://directory.gohighlevel.com/india/pune/certified-admins/kiran-kshirsagar"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[color:var(--accent)] underline decoration-[color:var(--accent)]/40 underline-offset-4 hover:decoration-[color:var(--accent)]"
              >
                HighLevel Certified Admin
              </a>
              , trusted to build and white-label agency-grade sub-accounts.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-hairline pt-8">
            {[
              { k: "2012", v: "Delivering since" },
              { k: "Pune, IN", v: "Home base" },
              { k: "Global", v: "Client footprint" },
            ].map((m) => (
              <div key={m.v}>
                <div className="font-display text-3xl md:text-4xl tracking-tight">{m.k}</div>
                <div className="mono-label mt-2">{m.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
